import { gql } from '@apollo/client';


//DELETE mutations

export const DELETE_COUPON = gql`
  mutation DeleteCupon($subjectId: ID!) {
    deleteCupon(documentId: $subjectId) {
      documentId
    }
  }
`;


export const GET_USER_COUPONS = gql`
  query getUserCoupons($limit: Int, $offset: Int) {
    myCupons(limit: $limit, offset: $offset) {
      documentId
      name
      description
      percentage
      imageLink
      createdAt
      webLink
      qrLink
    }
  }
`;
